import { Navigate } from 'react-router-dom';
import { lazy } from 'react';
import MainLayout from 'views/components/layout/MainLayout';
import Loadable from 'views/components/ui-component/Loadable';

// lazy load all components
const ExamService = Loadable(lazy(() => import('views/pages/service/exam')));
const ExamRegister = Loadable(lazy(() => import('views/pages/service/exam/ExamRegister')));
const ExamDetail = Loadable(lazy(() => import('views/pages/service/exam/ExamDetail')));
const UserInfo = Loadable(lazy(() => import('views/pages/authentication/user-auth/UserInfo')));
const UserEdit = Loadable(lazy(() => import('views/pages/authentication/user-auth/UserEdit')));
const UserPasswordChange = Loadable(lazy(() => import('views/pages/management/user/UserPasswordChange')));

// ==============================|| MANAGER ROUTES ||============================== //

const ManagerRoutes = {
    path: '/',
    element: <MainLayout />,
    children: [
        {
            index: true,
            element: <Navigate to="/service/exam/all" replace />
        },
        {
            path: 'service',
            children: [
                {
                    path: 'exam',
                    children: [
                        {
                            path: ':status/:id',
                            element: <ExamDetail />
                        },
                        {
                            path: 'register',
                            element: <ExamRegister />
                        },
                        {
                            path: 'all',
                            element: <ExamService />
                        },
                        {
                            path: '',
                            element: <ExamService />
                        },
                        {
                            path: '*',
                            element: <ExamService />
                        }
                    ]
                }
            ]
        },
        {
            path: 'auth',
            children: [
                {
                    path: 'me',
                    element: <UserInfo />
                },
                {
                    path: 'me/edit',
                    element: <UserEdit />
                },
                {
                    path: 'password/change',
                    element: <UserPasswordChange />
                }
            ]
        },
        {
            path: '*',
            element: <Navigate to="/service/exam/all" replace />
        }
    ]
};

export default ManagerRoutes;
